import React, { useState } from "react";
import { DoubleBounce } from "styled-spinkit";
import { Box, Button, Paper, Typography } from "@material-ui/core";

interface InfoWindowExProps {
  //@ts-ignore
  sendToWaypoint(event: google.maps.MapMouseEvent, name?: string): void;
  //@ts-ignore
  event: google.maps.MapMouseEvent;
  name?: string;
}

interface InfoWindowExState {
  waitingForResponse: boolean;
  responseReceived: boolean;
}

const DEFAULT_STATE: InfoWindowExState = {
  waitingForResponse: false,
  responseReceived: false,
};

export default function InfoWindowEx({
  event,
  name,
  sendToWaypoint,
}: InfoWindowExProps) {
  const [state, setState] = useState(DEFAULT_STATE);
  if (state.waitingForResponse) {
    return (
      <Paper>
        <DoubleBounce></DoubleBounce>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            sendToWaypoint(event, name);
            setState({ ...state, waitingForResponse: true });
          }}
        >
          Retry
        </Button>
      </Paper>
    );
  } else {
    return (
      <Paper>
        <Typography>Send user here?</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            sendToWaypoint(event, name);
            setState({ ...state, waitingForResponse: true });
          }}
        >
          Yes
        </Button>
      </Paper>
    );
  }
}
